import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ForYouSection() {
  return <section className="py-20 bg-[#FAF5EF] px-4" data-id="element-68">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-16 shadow-sm border border-[#C06B6B]/10" data-id="element-69">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gray-900 mb-12" data-id="element-70">
          🌸 Esto es para ti si…
        </h2>

        <div className="grid md:grid-cols-2 gap-y-6 gap-x-12" data-id="element-71">
          {['Cuidas a todos menos a ti', 'Funcionas aunque estés agotada por dentro', 'Duermes, pero no descansas', 'Sonríes, pero estás cansada', 'Tu mente está cansada de sostenerlo todo'].map((item, i) => <div key={i} className="flex items-center gap-4" data-id="element-72">
              <CheckCircle2 className="h-6 w-6 text-[#C4973B] flex-shrink-0" data-id="element-73" />
              <span className="text-lg text-gray-700" data-id="element-74">{item}</span>
            </div>)}
        </div>

        <div className="mt-12 text-center bg-[#FDF8F4] p-6 rounded-xl" data-id="element-75">
          <p className="text-xl text-gray-800" data-id="element-76">
            <span className="font-bold text-[#C06B6B]" data-id="element-77">
              👉 Este protocolo le muestra que ya no está sola.
            </span>
          </p>
        </div>
      </div>
    </section>;
}